export default function LegalDocumentLayout({ title, lastUpdated, children }) {
  return (
    <section className="ticket-page">
      <div className="container ticket-legal">
        <header className="ticket-legal__header">
          <p className="ticket-eyebrow">Legal</p>
          <h1 className="ticket-legal__title">{title}</h1>
          <p className="ticket-legal__updated">Last updated: {lastUpdated}</p>
        </header>
        <article className="ticket-legal__content">{children}</article>
      </div>
    </section>
  );
}

export function LegalIntro({ children }) {
  return <p>{children}</p>;
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2>{title}</h2>
      <div>{children}</div>
    </section>
  );
}

export function LegalSubsection({ title, children }) {
  return (
    <div>
      {title && <h3>{title}</h3>}
      <div>{children}</div>
    </div>
  );
}

export function LegalP({ children }) {
  return <p>{children}</p>;
}

export function LegalList({ items }) {
  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
}

export function LegalStrong({ children }) {
  return <strong>{children}</strong>;
}
